import React from 'react';
import { Box } from '@mui/material';

interface Props {
  levels: number[];
  active?: boolean;
  color?: string;
  inactiveColor?: string;
  dotColor?: string;
  barWidth?: number;
  maxHeight?: number;
}

export const VoiceRecordingWaveform: React.FC<Props> = ({
  levels,
  active = true,
  color = 'rgba(60,64,67,0.75)',
  inactiveColor = 'rgba(60,64,67,0.2)',
  dotColor = 'rgba(60,64,67,0.35)',
  barWidth = 2.5,
  maxHeight = 24,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.3,
        flex: 1,
        minWidth: 0,
        height: maxHeight,
        overflow: 'hidden',
      }}
    >
      {levels.map((level, i) => {
        const amp = active ? level : 0.08;
        const isDot = amp < 0.18;
        if (isDot) {
          return (
            <Box
              key={i}
              sx={{
                width: 3,
                height: 3,
                borderRadius: '50%',
                bgcolor: dotColor,
                flexShrink: 0,
              }}
            />
          );
        }
        return (
          <Box
            key={i}
            sx={{
              width: barWidth,
              borderRadius: 1.25,
              height: Math.max(4, amp * maxHeight),
              bgcolor: active ? color : inactiveColor,
              flexShrink: 0,
              transition: 'height 0.06s linear',
            }}
          />
        );
      })}
    </Box>
  );
};
